import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { db, timestamp } from '../firebase';
import { Schedule } from '../models/schedule';

export const useScheduleList = (groupId: string) => {
  const scheduleCollection = useMemo(
    () => collection(db, '/groups', groupId, 'schedules'),
    [groupId]
  );
  const now = timestamp(new Date());

  const { data: upcomingSchedules = [] } = useQuery(
    `/group/${groupId}/schedules/upcoming`,
    async () => {
      const snapshot = await getDocs(
        query(scheduleCollection, where('start', '>=', now), orderBy('start'))
      );
      const result: Schedule[] = [];
      snapshot.forEach((d) => {
        if (d.exists()) {
          result.push({ id: d.id, ...d.data() } as Schedule);
        }
      });
      return result;
    }
  );

  const { data: pastSchedules = [] } = useQuery(
    `/group/${groupId}/schedules/past`,
    async () => {
      const snapshot = await getDocs(
        query(scheduleCollection, where('start', '<', now), orderBy('start'))
      );
      const result: Schedule[] = [];
      snapshot.forEach((d) => {
        if (d.exists()) {
          result.push({ id: d.id, ...d.data() } as Schedule);
        }
      });
      return result;
    }
  );

  return {
    upcomingSchedules,
    pastSchedules,
  };
};
